import React from 'react';
import PropTypes from 'prop-types';

import { colorsProps, colorsClass } from '../utilities/colors';
import { sizingProps, sizingClass } from '../utilities/sizing';
import { spacingProps, spacingClass } from '../utilities/spacing';
import { bordersProps, bordersClass } from '../utilities/borders';

import cn from 'classnames';

const NavBar = (props) => {
  let { tag: Tag, children, className, direction, ...attributes } = props;

  let colors, sizing, spacing, borders;
  [colors, attributes] = colorsClass(attributes);
  [sizing, attributes] = sizingClass(attributes);
  [spacing, attributes] = spacingClass(attributes);
  [borders, attributes] = bordersClass(attributes);

  return (
    <Tag 
      {...attributes} 
      className={cn(
        'navbar', 
        className,
        sizing,
        spacing,
        borders,
        colors,
      )}
    >
      {children}
    </Tag>
  );
};

NavBar.propTypes = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  children: PropTypes.node,
  className: PropTypes.string,
  ...sizingProps(),
  ...spacingProps(),
  ...colorsProps(),
  ...bordersProps(),
};

NavBar.defaultProps = {
  tag: 'nav',
  className: '',
};

export default NavBar;
